<template>
  <gray-bg>
    <p>Bitte melden Sie sich an, um auf alle Inhalte zuzugreifen.</p>

    <luma-form form-id="login" :submit-function="this.login" classes="m-t">

      <b-form-group>
        <b-form-input :placeholder="$t('validations.username')" type="text" v-model="username" ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input :placeholder="$t('validations.password')" type="password" v-model="password" ></b-form-input>
      </b-form-group>
      <b-button variant="primary" block class="full-width m-b" type="submit">Anmelden</b-button>

      <b-link @click="$router.push({name: 'login-forgot-data'})">{{ $t('links.auth.forgot_password') }}</b-link>
    </luma-form>
  </gray-bg>
</template>

<script>
  import LumaForm from "@/components/LumaForm";
  import GrayBg from "@/layout/GrayBg";

  export default {
    name: "public-auth-login",
    components: {
      GrayBg,
      LumaForm
    },
    data() {
      return {
        username: '',
        password: ''
      }
    },
    methods: {
      login: async function () {
        const result = await this.$store.dispatch("users/login", {
          username: this.username,
          password: this.password
        })

        if (result.status !== 'success') return

        this.$router.push({name:'general-dashboard'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Public/Auth/Login.vue